/**
 * World links that open the app. On the web: the address this page opened with, which then goes
 * back to `/`. In the app: the universal link it was opened with, and every one after.
 */
import { App } from '@capacitor/app';

import { isNative } from './env';
import { codeInLink } from './links';

/** The same link can arrive twice when the app starts from it; once is enough. */
const AGAIN_MS = 3000;

/** Calls `onLink` with the code of every world link that opens the app; returns a stop function. */
export function watchLinks(onLink: (code: string) => void): () => void {
  if (!isNative) {
    const code = codeInLink(location.href);
    if (code) {
      history.replaceState(null, '', '/');
      onLink(code);
    }
    return () => undefined;
  }
  let last = '';
  let lastAt = 0;
  const seen = (url: string | undefined): void => {
    const code = url ? codeInLink(url) : null;
    const now = performance.now();
    if (!code || (code === last && now - lastAt < AGAIN_MS)) return;
    last = code;
    lastAt = now;
    onLink(code);
  };
  void App.getLaunchUrl().then((launch) => seen(launch?.url));
  const handle = App.addListener('appUrlOpen', ({ url }) => seen(url));
  return () => {
    void handle.then((h) => h.remove());
  };
}
